module.exports = __webpack_public_path__ + "static/media/person-icon..40fdd89d.svg";